<template>
    <div>
        <section class="section">
            <br><br>
            <div class="container">
                <h1 class="title has-text-centered">Downloads</h1>
                <br>
                <p>Please find below examples of our customer documents as well as our FFC certificates:</p>
                <br>
                <ul class="ul-bullets">
                    <li id="ffc">FFC certificates:
                        <ul class="ul-bullets">
                            <li>
                                <a class="plain-link" download href="/docs/FFC JBS 2020.pdf" target="_blank">For NestEgg</a>
                            </li>
                            <li>
                                <a class="plain-link" download href="/docs/FFC Helen Hoekstra 2020.pdf" target="_blank">For our Principal Agent</a>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <a class="plain-link" download href="/docs/NestEgg Sample Preliminary Valuation.pdf" target="_blank">Preliminary Valuation Report</a>
                    </li>
                    <li>
                        <a class="plain-link" download href="/docs/NestEgg Sample Listing Agreement - Freehold.pdf" target="_blank">Listing Agreement - Freehold</a>
                    </li>
                    <li>
                        <a class="plain-link" download href="/docs/NestEgg Sample Listing Agreement - Sectional Title.pdf" target="_blank">Listing Agreement - Sectional Title</a>
                    </li>
                    <li>
                        <a class="plain-link" download href="/docs/NestEgg Sample OTP - Freehold.pdf" target="_blank">OTP (Offer to Purchase) - Freehold</a>
                    </li>
                    <li>
                        <a class="plain-link" download href="/docs/NestEgg Sample OTP - Sectional Title.pdf" target="_blank">OTP (Offer to Purchase) - Sectional Title</a>
                    </li>
                </ul>
            </div>
        </section>
    </div>
</template>

<script>
    export default {}
</script>

<style lang="scss">
</style>